import { render, staticRenderFns } from "./no-img.vue?vue&type=template&id=3277a4ff&scoped=true&"
import script from "./no-img.vue?vue&type=script&lang=js&"
export * from "./no-img.vue?vue&type=script&lang=js&"
import style0 from "./no-img.vue?vue&type=style&index=0&id=3277a4ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3277a4ff",
  null
  
)

export default component.exports